/* Tab styles — 6 variations. Each receives the same {onLogin, onApply} contract. */

const baseTd = (s) => ({ "data-testid": s });

export function TabsSplit({ onLogin, onApply }) {
  return (
    <div className="flex flex-col sm:flex-row gap-px bg-black border border-black">
      <button
        {...baseTd("member-login-btn")}
        onClick={onLogin}
        className="flex-1 bg-white text-black uppercase tracking-[0.3em] text-xs py-5 hover:bg-black hover:text-white transition-colors"
      >
        Member Login
      </button>
      <button
        {...baseTd("apply-membership-btn")}
        onClick={onApply}
        className="flex-1 bg-black text-white uppercase tracking-[0.3em] text-xs py-5 hover:bg-neutral-800 transition-colors"
      >
        Apply for Membership
      </button>
    </div>
  );
}

export function TabsPills({ onLogin, onApply }) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      <button
        {...baseTd("member-login-btn")}
        onClick={onLogin}
        className="rounded-full border border-black px-8 py-3 uppercase tracking-[0.28em] text-xs hover:bg-black hover:text-white transition-colors"
      >
        Member Login
      </button>
      <button
        {...baseTd("apply-membership-btn")}
        onClick={onApply}
        className="rounded-full bg-black text-white px-8 py-3 uppercase tracking-[0.28em] text-xs hover:bg-neutral-800 transition-colors"
      >
        Apply for Membership
      </button>
    </div>
  );
}

export function TabsOutlined({ onLogin, onApply }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <button
        {...baseTd("member-login-btn")}
        onClick={onLogin}
        className="border border-black bg-white text-black uppercase tracking-[0.3em] text-xs py-5 hover:bg-neutral-100 transition-colors"
      >
        Member Login
      </button>
      <button
        {...baseTd("apply-membership-btn")}
        onClick={onApply}
        className="border border-black bg-white text-black uppercase tracking-[0.3em] text-xs py-5 hover:bg-neutral-100 transition-colors"
      >
        Apply for Membership
      </button>
    </div>
  );
}

export function TabsUnderline({ onLogin, onApply }) {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
      <button
        {...baseTd("member-login-btn")}
        onClick={onLogin}
        className="uppercase tracking-[0.32em] text-xs pb-1 border-b border-black hover:opacity-60 transition-opacity"
      >
        Member Login
      </button>
      <span className="hidden sm:block w-1.5 h-1.5 bg-black rounded-full" aria-hidden />
      <button
        {...baseTd("apply-membership-btn")}
        onClick={onApply}
        className="uppercase tracking-[0.32em] text-xs pb-1 border-b border-black hover:opacity-60 transition-opacity"
      >
        Apply for Membership
      </button>
    </div>
  );
}

export function TabsStacked({ onLogin, onApply }) {
  return (
    <div className="flex flex-col gap-3 max-w-md mx-auto w-full">
      <button
        {...baseTd("member-login-btn")}
        onClick={onLogin}
        className="border border-black bg-white text-black uppercase tracking-[0.3em] text-xs py-4 hover:bg-black hover:text-white transition-colors"
      >
        Member Login
      </button>
      <button
        {...baseTd("apply-membership-btn")}
        onClick={onApply}
        className="bg-black text-white uppercase tracking-[0.3em] text-xs py-4 hover:bg-neutral-800 transition-colors"
      >
        Apply for Membership
      </button>
    </div>
  );
}

export function TabsArrow({ onLogin, onApply }) {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16">
      <button
        {...baseTd("member-login-btn")}
        onClick={onLogin}
        className="group inline-flex items-center gap-3 uppercase tracking-[0.32em] text-xs hover:opacity-60 transition-opacity"
      >
        <span>Member Login</span>
        <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
      </button>
      <button
        {...baseTd("apply-membership-btn")}
        onClick={onApply}
        className="group inline-flex items-center gap-3 uppercase tracking-[0.32em] text-xs hover:opacity-60 transition-opacity"
      >
        <span>Apply for Membership</span>
        <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
      </button>
    </div>
  );
}

export const TAB_STYLES = [
  { id: "split", name: "Split Bar", Comp: TabsSplit },
  { id: "pills", name: "Pills", Comp: TabsPills },
  { id: "outlined", name: "Outlined", Comp: TabsOutlined },
  { id: "underline", name: "Underline", Comp: TabsUnderline },
  { id: "stacked", name: "Stacked", Comp: TabsStacked },
  { id: "arrow", name: "Arrow Links", Comp: TabsArrow },
];
